import { render, staticRenderFns } from "./DiscussionItem.vue?vue&type=template&id=78e66202&scoped=true&lang=html"
import script from "./DiscussionItem.vue?vue&type=script&lang=js"
export * from "./DiscussionItem.vue?vue&type=script&lang=js"
import style0 from "./DiscussionItem.vue?vue&type=style&index=0&id=78e66202&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78e66202",
  null
  
)

export default component.exports